import { render } from "./MediaEditing.vue?vue&type=template&id=11843e64"
import script from "./MediaEditing.vue?vue&type=script&lang=js"
export * from "./MediaEditing.vue?vue&type=script&lang=js"
script.render = render

export default script